<template>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32"><path fill-rule="evenodd" d="M4.667 20.795V5.9h22.667v14.894H4.667zm-2-15.21C2.667 4.708 3.413 4 4.334 4h23.333c.92 0 1.667.71 1.667 1.584v15.528c0 .875-.747 1.584-1.667 1.584h-9.333v2.07h3.664c.553 0 1 .425 1 .95 0 .525-.447.95-1 .95H10.665c-.552 0-1-.425-1-.95 0-.525.448-.95 1-.95h3.669v-2.07h-10c-.92 0-1.667-.71-1.667-1.584V5.584zm13.65 3.891a.333.333 0 00-.634 0l-.656 2.019a.334.334 0 01-.317.23h-2.122a.333.333 0 00-.196.603l1.717 1.248a.333.333 0 01.121.373l-.656 2.018c-.1.307.252.563.513.373l1.717-1.248a.333.333 0 01.392 0l1.717 1.248a.333.333 0 00.513-.373l-.656-2.018a.333.333 0 01.121-.373l1.718-1.248a.333.333 0 00-.196-.603H17.29a.334.334 0 01-.317-.23l-.656-2.019z" clip-rule="evenodd"/></svg>
</template>

<script>
export default {
  name: 'webSystemFaviconOutline'
}
</script>
